import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

// export function passwordMatchValidator(
//     control: AbstractControl
// ): ValidationErrors | null {
//     const password = control.get('password')?.value;
//     const confirmPassword = control.get('confirmPassword')?.value;

//     if (password !== confirmPassword) {
//         control.get('confirmPassword')?.setErrors({ passwordMismatch: true });
//         return { passwordMismatch: true };
//     } else {
//         control.get('confirmPassword')?.setErrors(null);
//         return null;
//     }
// }

export function passwordMatchValidator(
    control: AbstractControl
): ValidationErrors | null {
    const password = control.get('password')?.value;
    const confirmPasswordControl = control.get('confirmPassword');

    if (!confirmPasswordControl) {
        return null;
    }

    // Get current errors
    const currentErrors = confirmPasswordControl.errors || {};

    // If confirmPassword is empty, don't set passwordMismatch (allow required to take effect)
    if (!confirmPasswordControl.value) {
        return null;
    }

    // Check for mismatch
    if (password !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ ...currentErrors, passwordMismatch: true });
        return { passwordMismatch: true };
    }

    // Remove only passwordMismatch error, keep others (e.g., required)
    if (currentErrors["passwordMismatch"]) {
        delete currentErrors["passwordMismatch"];
        confirmPasswordControl.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
    }

    return null;
}


export function strongPasswordValidator(control: AbstractControl): ValidationErrors | null{
    const password: string = control.value;

    const hasMin8Chars = password.length >= 8;
    const hasUpperChar = /[A-Z]/.test(password);
    const hasLowerChar = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    if (!hasMin8Chars || !hasUpperChar || !hasLowerChar || !hasNumber) {
        return {
            passwordStrength: {
                hasMin8Chars,
                hasUpperChar,
                hasLowerChar,
                hasNumber
            }
        };
    }

    return null
}

// Custom ErrorStateMatcher
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: any): boolean {
        const isSubmitted = form && form.submitted;
        return !!(
            control &&
            control.invalid &&
            (control.dirty || control.touched || isSubmitted)
        );
    }
}